import React from "react";
import "./WarningDialog.css";

const WarningDialog = ({
  isOpen,
  onClose,
  message,
  warningCount,
  totalWarnings = 3,
  hideWarningCount = false,
}) => {
  // console.log("[WarningDialog] Render", { isOpen, message, warningCount });

  if (!isOpen) return null;

  return (
    <div className="warning-dialog-overlay">
      <div className="warning-dialog">
        <button className="close-button" onClick={onClose}>
          ✕
        </button>

        <div className="warning-content">
          <div className="warning-icon">⚠️</div>
          <h3>Warning!</h3>
          {typeof message === "string" ? <p>{message}</p> : message}
          {!hideWarningCount && warningCount && (
            <div className="warning-count">
              Warning {warningCount} of {totalWarnings}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WarningDialog;
